import React,{ useState,}from 'react'
import { Modal,Form,App, Input} from 'antd';
import { useBnsXiangMuBanBenAddMutation } from '../../store/BnsKeJiApi';
import { PlusSquareOutlined } from '@ant-design/icons';
import UploadOne from '../../cpn/UploadOne';
const { TextArea } = Input;
function SketchAdd(props) {   
    const {message} = App.useApp() 
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = useBnsXiangMuBanBenAddMutation()
    const [info,setInfo] = useState({
        'bxmbb_bxm_id': props.bxm_id,
        'bxmbb_bxm_name': props.bxm_name,
        'bxmbb_cid': props.eu_id,
        'bxmbb_cname': props.eu_name,
        'bxmbb_name': '',
        'bxmbb_content': '',
        'bxmbb_image': '',
        bxmbb_yh_id:props.yh_id,
        bxmbb_yh_name:props.yh_name,  
        bxmbb_xq_id:props.bxmxq_id,
        bxmbb_xq_name:props.bxmxq_name,
    });
    return (
            <>
                <a onClick={() => {setOpen(true)}}><PlusSquareOutlined />  新增效果图</a>
                <Modal
                    width={1000}
                    open={open}
                    title='新增效果图'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add(info).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_sketch_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <Form.Item
                            name="bxmbb_name"
                            label="名称"
                            wrapperCol={{ span: 20 }}
                        >
                            <Input
                                onChange={(e) => {
                                    setInfo(prevState => ({ ...prevState, bxmbb_name: e.target.value }))
                                }}
                            />
                        </Form.Item>
                        <UploadOne
                            fileStr={(fileStr) => { setInfo(prevState => ({ ...prevState, bxmbb_image: fileStr })) }} 
                            label="效果图"
                            name="bxmbb_image"
                            maxCount={1}
                        />
                        <Form.Item
                            name="bxmbb_content"
                            label="备注"
                            wrapperCol={{ span: 20 }}
                        >
                            <TextArea
                                onChange={(e) => {
                                    setInfo(prevState => ({ ...prevState, bxmbb_content: e.target.value }))
                                }}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        )
}

export default SketchAdd
